import React from 'react';
import type { CFMiniProgram } from '@types';
import { HOST } from '@constants';
import { Validator } from '@components/Validator';
import Tip from '@components/Tip';
import { Collapse } from '@components/Collapse';
import Textarea from '@components/Textarea';
import useTextareaHandelrs from '@hooks/useTextareaHandelrs';
import TextLink from '@components/TextLink';
import { useCustomFeature } from '../CustomFeatureContext';

export function CMiniProgramSetting() {
  const { data, setData } = useCustomFeature<CFMiniProgram>();
  const idHandlers = useTextareaHandelrs('trim', (val) =>
    setData((draft) => {
      draft.id = val;
    })
  );
  const urlHandlers = useTextareaHandelrs('trim', (val) =>
    setData((draft) => {
      draft.url = val;
    })
  );
  return (
    <Collapse title="小程序设置">
      <div className="mb-10">微信小程序ID：</div>
      <Validator
        value={data.id}
        validFn={(value) => !!value}
        warningMessage="请输入小程序ID"
      >
        {({ value, warning }) => (
          <Textarea
            scheme="dark"
            className="h-115"
            placeholder="请输入小程序ID，gh_开头的ID"
            maxLength={50}
            value={value}
            warning={warning}
            {...idHandlers}
          />
        )}
      </Validator>
      <div className="mt-20 mb-10">微信小程序页面路径：</div>
      <Textarea
        scheme="dark"
        className="h-115"
        placeholder="请输入小程序页面路径及参数"
        maxLength={500}
        value={data.url}
        {...urlHandlers}
      />
      <Tip className="mt-10 text-orange">
        注：小程序按钮仅支持在微信中打开，其他应用中打开时将会引导在微信中打开；不填写页面路径时默认打开小程序首页
      </Tip>
      <TextLink
        className="mt-10 text-sm"
        href={`${HOST}/bbs/article?id=1214`}
        target="_blank"
      >
        {'查看获取小程序ID和页面路径方法 >'}
      </TextLink>
    </Collapse>
  );
}
